import React from 'react';

export default function ModalContent({ children, style }) {
	return <div className="modal-content" style={style}>
		{children}
	</div>;
}
